// @flow

import _dateFormat from "dateformat";

const parseDateISOString = s => {
    const ds = s.split(/\D/).map(sub => parseInt(sub, 10));
    ds[1] -= 1; // adjust month
    return new Date(...ds);
};

const dateFormat = (dateString, format = "mmm dS yyyy") => {
    const date = parseDateISOString(dateString);
    return _dateFormat(date, format);
};

export default dateFormat;



// WEBPACK FOOTER //
// ./src/utils/localdateformat.js